/** Internal dependencies */
import whenDocumentReady from '../../../../../assets/src/scripts/utilities/whenDocumentReady';

whenDocumentReady(initWidget);

function initWidget() {
    document.querySelectorAll('.ct_button.share .btn').forEach(function (element) {
        element.closest('.ct_button').querySelector('.share-buttons').classList.remove('.wait-for-init');
        element.addEventListener('click', handleShareButtonClick);
    });
}

function handleShareButtonClick(e) {
    e.preventDefault();
    let shareButtonContainer = e.target.closest('.ct_button').querySelector('.share-buttons');
    if (shareButtonContainer.classList.contains('show')) {
        shareButtonContainer.classList.remove('show');
    } else {
        shareButtonContainer.classList.add('show');
    }
}
